// Loaded into an AudioWorkletGlobalScope via a Blob URL (see audio-in.ts) so the
// widget stays a single bundled file — no second script to host/fetch.
export const CAPTURE_WORKLET_SOURCE = `
class ArtisCaptureProcessor extends AudioWorkletProcessor {
  constructor() {
    super();
    this.buffer = [];
    this.bufferedSamples = 0;
    this.chunkSamples = 3200; // 200ms @ 16kHz
  }

  process(inputs) {
    const input = inputs[0]?.[0];
    if (!input) return true;
    this.buffer.push(input.slice());
    this.bufferedSamples += input.length;
    if (this.bufferedSamples >= this.chunkSamples) {
      const merged = new Float32Array(this.bufferedSamples);
      let offset = 0;
      for (const chunk of this.buffer) {
        merged.set(chunk, offset);
        offset += chunk.length;
      }
      const pcm16 = new Int16Array(merged.length);
      for (let i = 0; i < merged.length; i++) {
        const s = Math.max(-1, Math.min(1, merged[i]));
        pcm16[i] = s < 0 ? s * 32768 : s * 32767;
      }
      this.port.postMessage(pcm16.buffer, [pcm16.buffer]);
      this.buffer = [];
      this.bufferedSamples = 0;
    }
    return true;
  }
}
registerProcessor("artis-capture-processor", ArtisCaptureProcessor);
`;
